import http from "@/http/aisea/axios";
const resource = "/vessel_report/enterprise/reports/export";

export default {
  export(params) {
    return http.get(`${resource}`, {
      params: params,
      responseType: 'blob',
      headers: { Accept: 'application/zip' }
    });
  }
};
